import { track } from 'src/lib/analytics/utils';
import { ProductId } from 'src/replicant/iap';

type PurchaseCompleteAnalytics = {
  feature: string;
  subFeature: string;
  productID: ProductId;
};

/**
 * This event with HidePurchaseComplete can help track if all animations work well. We can compare both rates to detect animation issues.
 *
 * @trigger Before PopupNewPurchaseComplete show
 */
export function trackShowPurchaseComplete(revenue: PurchaseCompleteAnalytics) {
  track('ShowPurchaseComplete', {
    feature: revenue.feature,
    subFeature: revenue.subFeature,
    productID: revenue.productID,
  });
}

/**
 * After PopupNewPurchaseComplete hide, and animations complete.
 *
 * @trigger After PopupNewPurchaseComplete hide, and animations complete
 */
export function trackHidePurchaseComplete(revenue: PurchaseCompleteAnalytics) {
  track('HidePurchaseComplete', {
    feature: revenue.feature,
    subFeature: revenue.subFeature,
    productID: revenue.productID,
  });
}

/**
 * How often do users change their minds about purchasing an item
 *
 * @trigger Before PopupPurchaseCanceled show, with type: needSupport
 */
export function trackShowPurchaseCanceled(analytics: {
  feature: string;
  subFeature: string;
  productID: ProductId;
}) {
  track('ShowPurchaseCanceled', {
    feature: analytics.feature,
    subFeature: analytics.subFeature,
    productID: analytics.productID,
  });
}

/**
 * How many canceled were done by technical issues
 *
 * @trigger Before PopupPurchaseCanceled show, with type: ‘failed’
 */
export function trackShowPurchaseFailed(analytics: {
  feature: string;
  subFeature: string;
  productID: ProductId;
}) {
  track('ShowPurchaseFailed', {
    feature: analytics.feature,
    subFeature: analytics.subFeature,
    productID: analytics.productID,
  });
}

/**
 * The user closed PopupPurchaseCanceled by pressing: 'Contact Support' button. With type: 'error' or 'cancel'
 *
 * @trigger Before PopupPurchaseCanceled show, with type: 'error' or 'cancel'
 */
export function trackPurchaseSupportRequest(
  analytics: {
    feature: string;
    subFeature: string;
    productID: ProductId;
  },
  opts: {
    cancellationType: 'error' | 'cancel';
  },
) {
  track('PurchaseSupportRequest', {
    feature: analytics.feature,
    subFeature: analytics.subFeature,
    productID: analytics.productID,
    cancellationType: opts.cancellationType,
  });
}

/**
 * The user closed PopupPurchaseCanceled by pressing: 'X' close button' button. With type: 'error' or 'cancel'
 *
 * @trigger Before PopupPurchaseCanceled show, with type: 'error' or 'cancel'
 */
export function trackPurchaseSupportReject(
  analytics: {
    feature: string;
    subFeature: string;
    productID: ProductId;
  },
  opts: {
    cancellationType: 'error' | 'cancel';
  },
) {
  track('PurchaseSupportReject', {
    feature: analytics.feature,
    subFeature: analytics.subFeature,
    productID: analytics.productID,
    cancellationType: opts.cancellationType,
  });
}
